import React, {useState} from 'react';

import { Tooltip} from 'antd';
import Icon from '@ant-design/icons';
import './AdnLanguagePicker.css'

// Fluency Icons
import {ReactComponent as fluencyFR} from '../../../assets/images/image_languages/icons8-france-48.svg'
import {ReactComponent as fluencyPT} from '../../../assets/images/image_languages/icons8-portugal-48.svg'
import {ReactComponent as fluencyGE} from '../../../assets/images/image_languages/icons8-germany-48.svg'
import {ReactComponent as fluencyGR} from '../../../assets/images/image_languages/icons8-greece-48.svg'
import {ReactComponent as fluencyIT} from '../../../assets/images/image_languages/icons8-italy-48.svg'
import {ReactComponent as fluencyES} from '../../../assets/images/image_languages/icons8-spain-48.svg'
import {ReactComponent as fluencyEN} from '../../../assets/images/image_languages/icons8-great-britain-48.svg'



function AdnLanguagePicker({ fluencyLanguages, setFluencyLanguages }) {
  return (
    <div className="profileFluency">
    <Tooltip title="French">
        <Icon id="iconFirst" component={fluencyFR} onClick={() => setFluencyLanguages(prev => ({...prev, fr: !prev.fr }))}
        className={!fluencyLanguages.fr ? "profileFluencyCheck hoveredIcon" : "hoveredIcon"}/>
    </Tooltip>
    <Tooltip title="German">
        <Icon component={fluencyGE} onClick={() => setFluencyLanguages(prev => ({...prev, ge: !prev.ge }))}
        className={!fluencyLanguages.ge ? "profileFluencyCheck hoveredIcon" : "hoveredIcon" }/>
    </Tooltip>
    <Tooltip title="English">
        <Icon component={fluencyEN} onClick={() => setFluencyLanguages(prev => ({...prev, en: !prev.en }))}
        className={!fluencyLanguages.en ? "profileFluencyCheck hoveredIcon" : "hoveredIcon" }/> 
    </Tooltip>
    <Tooltip title="Greek">
        <Icon component={fluencyGR} onClick={() => setFluencyLanguages(prev => ({...prev, gr: !prev.gr }))}
        className={!fluencyLanguages.gr ? "profileFluencyCheck hoveredIcon" : "hoveredIcon" }/>
    </Tooltip>
   
    <Tooltip title="Italian">
        <Icon component={fluencyIT} onClick={() => setFluencyLanguages(prev => ({...prev, it: !prev.it }))}
        className={!fluencyLanguages.it ? "profileFluencyCheck hoveredIcon" : "hoveredIcon" }/>
    </Tooltip>
    
    <Tooltip title="Portuguese">
        <Icon component={fluencyPT} onClick={() => setFluencyLanguages(prev => ({...prev, pt: !prev.pt }))}
        className={!fluencyLanguages.pt ? "profileFluencyCheck hoveredIcon" : "hoveredIcon" }/>
    </Tooltip>
    
    <Tooltip title="Spanish">
        <Icon component={fluencyES} onClick={() => setFluencyLanguages(prev => ({...prev, es: !prev.es }))}
        className={!fluencyLanguages.es ? "profileFluencyCheck hoveredIcon" : "hoveredIcon" }/>
    </Tooltip>
    
</div>                   
  );
}

export default AdnLanguagePicker;
